import { useProfile } from '@front/model'
import { type PermissionEntityId, type PermissionType, type WithEntityId } from '@terros/common'
import { parseAsBoolean, useQueryState } from 'nuqs'
import { type ReactNode } from 'react'
import { TButton, type TButtonProps } from '../buttons'
import { PermissionDrawer } from './Drawer'
import { PermissionTooltip, type PermissionTooltipProps } from './PermissionTooltip'

export type PermissionButtonProps = WithEntityId & {
  drawerTitle: ReactNode
  permissionType: PermissionType
  permissionEntityId?: PermissionEntityId
  buttonProps?: TButtonProps
}

export const ViewPermissionButton = ({
  entityId,
  drawerTitle,
  permissionType,
  permissionEntityId,
  buttonProps,
}: PermissionButtonProps): ReactNode => {
  const [viewPermissions, setViewPermissions] = useQueryState(
    `viewPermissionsFor${entityId}`,
    parseAsBoolean.withDefault(false)
  )

  const open = (): void => {
    setViewPermissions(true)
  }

  const close = (): void => {
    setViewPermissions(false)
  }

  return (
    <>
      <Wrapper permissionType={permissionType} targetId={entityId}>
        <TButton icon='shield' variant='secondary' onClick={open} {...buttonProps}>
          View Permissions
        </TButton>
      </Wrapper>
      <PermissionDrawer
        entityId={permissionEntityId ?? entityId}
        opened={viewPermissions}
        title={drawerTitle}
        onClose={close}
      />
    </>
  )
}

const Wrapper = (props: PermissionTooltipProps): ReactNode => {
  const { user } = useProfile()

  if (user?.userId === props.targetId) return props.children

  return <PermissionTooltip {...props} />
}
